import * as React from "react";
import {Bar} from 'react-chartjs-2';

export class BarChart extends React.Component<any> {
    constructor(props: any) {
        super(props);
    }

    render() {
        let {data, title} = this.props;
        const config = {
            labels: data.map((obj: any) => {
                return obj.label;
            }),
            datasets: [
                {
                    title: {
                        display: 'none'
                    },
                    label: '',
                    backgroundColor: 'rgb(41,138,61)',
                    borderColor: 'rgb(41,138,61)',
                    borderWidth: 1,
                    hoverBackgroundColor: 'rgba(41,138,61, 0.8)',
                    hoverBorderColor: 'rgba(41,138,61, 0.8)',
                    data: data.map((obj: any) => {
                        return obj.value;
                    }),
                    barThickness: 10,
                }
            ],
            barThickness: 10,
        };

        const options = {
            scales: {
                xAxes: [{
                    barPercentage: 0.5,
                    categoryPercentage: 0.5,
                    ticks: {
                        autoSkip: false,
                        maxRotation: 75,
                        minRotation: 45
                    }
                }],
                yAxes: [{
                    ticks: {
                        beginAtZero: true
                    }
                }]
            }
        };

        return (
            <>
                <h4 className="text-center py-3 mt-2">{title}</h4>
                <Bar
                    data={config} options={options}
                />
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/charts/BarChart.tsx